import { DialogActions } from "@material-ui/core";
import React from "react";
import { Table } from "react-bootstrap";
import NumberFormat from "react-number-format";
import Illustration from "../../../../partials/content/Illustration";
import { Typography } from "@material-ui/core";
import DialogLayout from "../../../../partials/content/DialogLayout";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";

function SalesProftiLoss({
  openProfitLoss,
  setOpenProfitLoss,
  values,
  property,
}) {
  let totalProfitLoss = 0;
  return (
    <DialogLayout
      open={openProfitLoss}
      title={`Sales Profit & Loss Analysis`}
      onCloseDialog={() => {
        setOpenProfitLoss(false);
      }}
      maxWIdth="lg"
    >
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <div className="card">
            <Table striped borderless size="sm" responsive="xl">
              {values[property] && values[property].length > 0 ? (
                <thead>
                  <tr>
                    <th style={{ width: "25%" }}>
                      <Typography className="mx-1 kt-font-bolder">
                        Item Name
                      </Typography>
                    </th>
                    <th style={{ width: "5%" }}>
                      <Typography className="mx-1 kt-font-bolder">
                        Quantity
                      </Typography>
                    </th>
                    <th style={{ width: "10%" }}>
                      <Typography className="mx-1 kt-font-bolder">
                        Unit
                      </Typography>
                    </th>
                    <th style={{ width: "15%" }}>
                      <Typography className="mx-1 kt-font-bolder text-right">
                        Minimum Price
                      </Typography>
                    </th>
                    <th style={{ width: "15%" }}>
                      <Typography className="mx-1 kt-font-bolder text-right">
                        Selling Price
                      </Typography>
                    </th>
                    <th style={{ width: "15%" }}>
                      <Typography className="mx-1 kt-font-bolder text-right">
                        Item Discount
                      </Typography>
                    </th>
                    <th style={{ width: "15%" }}>
                      <Typography className="mx-1 kt-font-bolder text-right">
                        Profit / Loss
                      </Typography>
                    </th>
                  </tr>
                </thead>
              ) : null}
              <tbody>
                {() => {
                  //totalCost = 0;
                  //totalPrice = 0;
                  totalProfitLoss = 0;
                }}
                {values[property] && values[property].length > 0 ? (
                  values[property].map((item, index) => {
                    let minimumPrice = 0;
                    let totalPricet = 0;
                    if (values.exchangeRate > 0) {
                      minimumPrice = (
                        (1 / values.exchangeRate) *
                        item.minimumPrice
                      ).toFixed(2);
                      totalPricet = (
                        (1 / values.exchangeRate) *
                        values.exchangeRate *
                        item.totalPrice
                      ).toFixed(2);
                    } else {
                      minimumPrice = 0;
                      totalPricet = 0;
                    }
                    //totalCost += minimumPrice;
                    //totalPrice += totalPricet;
                    totalProfitLoss +=
                      totalPricet - minimumPrice - item.discountAmount;
                    return (
                      <tr key={index}>
                        <td>
                          <Typography className="mx-1 my-1">
                            {item.itemType > 0 ? (
                              <span>
                                <BootstrapTooltip title={item.itemTypeName}>
                                  <span className="mr-2">
                                    <i
                                      className={
                                        item.itemType === 1
                                          ? "fas fa-boxes text-success"
                                          : item.itemType === 2
                                          ? "fas fa-tools text-primary"
                                          : item.itemType === 3
                                          ? "fas fa-building text-info"
                                          : item.itemType === 4
                                          ? "fas fa-boxes text-warning"
                                          : item.itemType === 5
                                          ? "fas fa-boxes text-danger"
                                          : null
                                      }
                                    ></i>
                                  </span>
                                </BootstrapTooltip>
                                <span>
                                  {item.itemCode} {item.itemName}
                                </span>
                              </span>
                            ) : (
                              <React.Fragment>
                                {item.itemCode} {item.itemName}
                              </React.Fragment>
                            )}
                          </Typography>
                        </td>
                        <td>
                          <Typography className="mx-1 my-1">
                            {item.qty}
                          </Typography>
                        </td>
                        <td>
                          <Typography className="mx-1 my-1">
                            {item.uomName}
                          </Typography>
                        </td>
                        <td>
                          <Typography component="div" className="mx-1 my-1">
                            <NumberFormat
                              value={minimumPrice}
                              displayType={"text"}
                              thousandSeparator={true}
                              decimalScale={2}
                              renderText={(value) => (
                                <div className="float-right">
                                  {values.currencyCode} {value}
                                </div>
                              )}
                            />
                          </Typography>
                        </td>
                        <td>
                          <Typography component="div" className="mx-1 my-1">
                            <NumberFormat
                              value={totalPricet}
                              displayType={"text"}
                              thousandSeparator={true}
                              decimalScale={2}
                              renderText={(value) => (
                                <div className="float-right">
                                  {values.currencyCode} {value}
                                </div>
                              )}
                            />
                          </Typography>
                        </td>
                        <td>
                          <Typography component="div" className="mx-1 my-1">
                            <NumberFormat
                              value={item.discountAmount}
                              displayType={"text"}
                              thousandSeparator={true}
                              decimalScale={2}
                              renderText={(value) => (
                                <div className="float-right">
                                  {values.currencyCode} {value}
                                </div>
                              )}
                            />
                          </Typography>
                        </td>
                        <td>
                          <Typography component="div" className="mx-1 my-1">
                            <NumberFormat
                              value={
                                totalPricet - minimumPrice - item.discountAmount
                              }
                              displayType={"text"}
                              thousandSeparator={true}
                              decimalScale={2}
                              renderText={(value) => (
                                <div className="float-right">
                                  {values.currencyCode} {value}
                                </div>
                              )}
                            />
                          </Typography>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td className="text-center py-3" colSpan="7">
                      <Illustration
                        imageSource="INVIFO Sales.png"
                        guidance="You don't have any Sales items which ready to be analyzed yet"
                        guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                        size="sm"
                      ></Illustration>
                    </td>
                  </tr>
                )}
              </tbody>
              {values[property] && values[property].length > 0 ? (
                <tfoot>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <th>
                      <Typography className="mx-1 kt-font-bolder text-right">
                        {totalProfitLoss >= 0 ? "Profit" : "Loss"} Estimation
                      </Typography>
                    </th>
                    <th>
                      <Typography component="div" className="mx-1 my-1">
                        <NumberFormat
                          value={totalProfitLoss}
                          displayType={"text"}
                          thousandSeparator={true}
                          decimalScale={2}
                          renderText={(value) => (
                            <div
                              className={`float-right ${
                                totalProfitLoss >= 0
                                  ? "text-success"
                                  : "text-danger"
                              }`}
                            >
                              {values.currencyCode} {value}
                            </div>
                          )}
                        />
                      </Typography>
                    </th>
                  </tr>
                </tfoot>
              ) : null}
            </Table>
          </div>
        </div>
      </div>
      <DialogActions>
        <button
          type="button"
          className="btn btn-label-danger btn-md btn-pill btn-bold"
          onClick={() => {
            setOpenProfitLoss(false);
          }}
        >
          <i className="fas fa-window-close"></i>
          Close
        </button>
      </DialogActions>
    </DialogLayout>
  );
}

export default SalesProftiLoss;
